import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SetTitle from '../../utils/set_title'
import { api } from '../../utils'
import { getDownloadFilename, triggerBlobDownload } from '../../utils/download'


export default function ContentGenFile() {
	SetTitle('Content Gen - Download File')
	const params = useParams()

	useEffect(() => {
		downloadData()
	}, [])

	const downloadData = () => {
		if (params?.id) {
			api.get('get-content-gen-file/' + params.id, { responseType: 'blob' })
				.then((response) => {
					const contentDisposition = response.headers['content-disposition'];
					const fileName = getDownloadFilename(contentDisposition, 'content_gen_file.xlsx')
					triggerBlobDownload(response.data, fileName)
					setTimeout(() => {
						window.location.href = '/content-gen'
					}, 5000)
				})
				.catch((error) => {
					console.error("Download failed:", error);
					setTimeout(() => {
						window.location.href = '/content-gen'
					}, 5000)
				});
		}
		else {
			setTimeout(() => {
				window.location.href = '/content-gen'
			}, 1000)
		}
	}

	return (
		<>
			<div className="bg-gradient-info secondary-page-title" >
				<div md={12} className="form-title">
					<i className="ni ni-folder-17 text-white" style={{ color: "white", fontSize: "35px" }}></i>
					<h1 className="page-title">Content Gen</h1>
				</div>
			</div>
			<div className="page-description">Download in corso...</div>
		</>
	)
}
